import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { EventsManagementService } from "@services/events-management.service";
import { PaginatorState } from "primeng/paginator";
import {
  BehaviorSubject,
  Subject,
  combineLatest,
  startWith,
  switchMap,
} from "rxjs";
import { EventsTableComponent } from "@shared/components/events-table/events-table.component";
import { CollaboratorToEventMapPipeTsPipe } from "./pipes/collaborator-to-event-map.pipe.ts.pipe";

@Component({
    selector: "app-my-assigned-events-list-container",
    imports: [
        CommonModule,
        EventsTableComponent,
        CollaboratorToEventMapPipeTsPipe,
    ],
    templateUrl: "./my-assigned-events-list-container.component.html",
    styleUrl: "./my-assigned-events-list-container.component.scss"
})
export class MyAssignedEventsListContainerComponent {
  private readonly eventsManagementService = inject(EventsManagementService);
  private readonly page$ = new BehaviorSubject<PaginatorState>({
    page: 0,
    rows: 5,
  });
  private readonly refreshList$ = new Subject<void>();

  myEvents$ = combineLatest([
    this.page$,
    this.refreshList$.pipe(startWith(null)),
  ]).pipe(
    switchMap(([page]) =>
      this.eventsManagementService.getMyAssignedEvents(page.page, page.rows),
    ),
  );

  handlePageChange(page: PaginatorState) {
    this.page$.next(page);
  }
}
